<h1 mat-dialog-title class="Title">レジカード</h1>
<div fxLayout="column">
<div fxFlex fxLayoutAlign="start center" fxLayoutGap="5px" style="margin-left:0px; margin-right:0px; width: auto;">
<div fxLayout="row wrap">
<div matPrefix class="Prefix FixedWidth">
<!-- <img style="width: 1165px;height:540px;" src="{{ImageData}}"> -->
<img style="width: 77vw;height:75vh;max-width: 77vw;" src="{{ImageData}}">
</div>
</div>
</div>
</div>

<mat-dialog-actions align="center">
<button mat-raised-button color="primary" style="width: 150px;" [disabled]=isInsertDisabled (click)="saveRegicardInfo()" >レジカード入力</button>
<button mat-raised-button color="accent" style="width: 150px;" [disabled]=isCancelDisabled (click)="cancelBooking()">キャンセル</button>
<button mat-raised-button color="primary" style="width: 150px;" [disabled]=isSaveDisabled (click)="continuteCheckin()">保存</button>
</mat-dialog-actions>
